import {Action, Argument} from "../../../feature/project/Shot";
import {Button, Flex, Input, Modal, Space, Tooltip, Typography} from "antd";
import React, {useEffect, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import LayerList from "../../common/LayerList";
import {ArgumentEditDialog} from "./ArgumentEditDialog";
import {useParams} from "react-router-dom";
import {deleteArgument, saveArgument} from "../../../feature/project/argumentSlice";
import {useAppDispatch} from "../../../feature/tools";

const {confirm} = Modal;
export const ActionEditDialog = (
    props: {
        action: Action;
        onSave: (action: Action) => void;
        onCancel: () => void;
    }
) => {
    const dispatch = useAppDispatch()
    const {projectId} = useParams()
    const [action, setAction] = useState(props.action)
    const [hasChanged, setHasChanged] = useState(false)
    const [title, setTitle] = useState(props.action.title)
    const [args, setArgs] = useState(props.action.arguments)
    const [showEditArgumentDialog, setShowEditArgumentDialog] = useState<Argument | undefined>(undefined)

    useEffect(() => {
            setHasChanged(props.action.title !== title || props.action.arguments !== args)
        }, [props.action, action, title, args]
    )

    const showConfirmArgumentDeletion = (item: Argument) => {
        confirm({
            title: 'Delete Argument',
            content: 'Are you sure you want to delete this argument?',
            icon: <></>,
            okText: 'Yes, delete',
            okButtonProps: {danger: true, type: 'primary'},
            cancelText: 'No',
            onOk() {
                if (projectId && item.id) {
                    dispatch(deleteArgument({projectId: parseInt(projectId), argumentId: item.id}))
                }
            },
        });
    }


    return (
        <Modal
            open={true}
            title={props.action.id ? 'Edit Action' : 'Add Action'}
            width={500}
            okText={'Save'}
            cancelText={'Close'}
            onCancel={props.onCancel}
            okButtonProps={
                {
                    disabled: !hasChanged
                }
            }
            onOk={() => props.onSave(
                {
                    ...props.action,
                    title: title,
                    arguments: args
                })
            }
        >
            <Flex gap={16}>
                <Space direction={'vertical'}
                       style={{width: '100%', maxHeight: 400, overflowY: 'auto', scrollbarWidth: "none"}}
                       size={16}>
                    <div>
                        <Typography style={{fontWeight: 700}}>Name</Typography>
                        <Input style={{flexGrow: 1}} value={title} onChange={(e) => setTitle(e.target.value)}/>
                    </div>
                    <div>
                        <Flex justify={'space-between'} className={'layer-group-title'} align={'center'}>
                            <Typography style={{fontWeight: 700}}>Arguments</Typography>
                            <Button
                                icon={<FontAwesomeIcon icon={faPlus}/>}
                                type={'text'}
                                disabled={!action.id}
                                onClick={() => {
                                    setShowEditArgumentDialog({title: "", type: "", value: ""} as Argument)
                                }}
                            />
                        </Flex>
                        {props.action.arguments ?
                            <LayerList
                                data={props.action.arguments}
                                itemStyle={{}}
                                clickable={true}
                                title={(item, index) =>
                                    <Flex
                                        align={'center'}
                                        style={{height: 32}}
                                        justify={'space-between'}>
                                        {item.title}
                                        <Tooltip title={item.value}>
                                            <div style={{
                                                color: "#aaa",
                                                maxWidth: 200,
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis'
                                            }}>{
                                                item.value
                                            }</div>
                                        </Tooltip>
                                    </Flex>}
                                onItemClick={(item) => {
                                    setShowEditArgumentDialog(item)
                                }}
                                onDeleteClick={(item) => {
                                    showConfirmArgumentDeletion(item)
                                }}
                                onEditClick={(item) => {
                                    setShowEditArgumentDialog(item)
                                }}
                            />
                            : <Flex align={'center'} justify={'center'} style={{padding: 20}}>No arguments added</Flex>
                        }
                    </div>
                </Space>
            </Flex>
            {showEditArgumentDialog ?
                <ArgumentEditDialog
                    action={action}
                    arg={showEditArgumentDialog}
                    onSave={(argument: Argument) => {
                        if (projectId && action.id) {
                            dispatch(saveArgument({
                                projectId: parseInt(projectId),
                                actionId: action.id,
                                argument: argument
                            }))
                            setShowEditArgumentDialog(undefined)
                        }
                    }}
                    onCancel={() => setShowEditArgumentDialog(undefined)}
                />
                : ''}
        </Modal>
    );
}